export default {
    getHeaderFields: state => state.headerFields,
    getFormActions: state => state.formActions,
    getActions: state => state.actions,
    getRowActions: state => state.rowActions,
    getAdditionalTableConfig: state => state.additionalTableConfig,
    isFormOpen: state => state.formIsOpen,
    isGridOpen: state => state.gridIsOpen,
}